import { callApi } from 'utils/api';

export function localAuthorityByIdFetch(LAID) {
  return callApi(`/user/local-authorities/${LAID}`);
}

export function subLocationsFetchByLAID(LAID) {
  return callApi(`/user/locations/${LAID}`);
}

export function localAuthoritiesFetch() {
  return callApi(`/user/local-authorities`);
}

export function universitiesFetch() {
  return callApi(`/user/universities`);
}



/** WEBPACK FOOTER **
 ** ./src/members/state/localAuthorities/api.js
 **/